export const connectToBinanceWebSocket = () => {
  return new WebSocket(
    `${process.env.REACT_APP_BINANCE_WEBSOCKET_BASE}ws/!ticker@arr@3000ms`
  );
};
